import React, { useContext, useEffect } from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";

import renderPageSection from "utils/renderPageSection";
import { HeaderContext } from "contexts/";

export default function FullPage(props) {
	const pageId = props.pageData?.items[0]?.sys.id;
	const fields = props.pageData?.items[0]?.fields;
	const pageSections = fields?.pageSections || [];
	const additionalData = props.additionalData;
	const title = fields?.pageTitle;
	const metaImage = fields?.metaImage;
	const metaDescription = fields?.metaDescription;
	const { setPageId } = useContext(HeaderContext);
	const noindex = props.noindex;

	useEffect(() => {
		//This handles the contentful page link button
		if (process.env.APP_ENV !== "production") {
			if (!pageId) {
				setPageId(null);
			} else {
				setPageId(pageId);
			}
		}
	});

	return (
		<>
			<NextSeo
				title={`${title} | AAPL`}
				description={metaDescription}
				noindex={noindex}
				openGraph={{
					images: [
						{
							url: "https:" + metaImage?.fields?.file?.url,
						},
					],
				}}
			/>
			<Head>
				<meta property="twitter:title" content={title} />
				<meta name="twitter:image" content={"https:" + metaImage?.fields?.file?.url} />
				<meta name="twitter:description" content={metaDescription} />
			</Head>
			<div>
				{/* //sanity check */}
				{!pageSections && (
					<>
						<h1>The new website is in development.</h1>
						<h2>This page needs content.</h2>
					</>
				)}
				{/* Loop over each page section and render */}
				{pageSections &&
					pageSections.map((pageSection, sectionIndex) => {
						return (
							<React.Fragment key={pageSection.sys.id}>
								{renderPageSection(pageSection, additionalData, sectionIndex + 1)}
							</React.Fragment>
						);
					})}
			</div>
		</>
	);
}
